import React from "react"
import type { ReactNode } from "react"

/**
 * Recursively extracts text content from a JSX tree.
 *
 * @example
 * extractText(<Button>Upgrade <strong>now</strong></Button>) // "Upgrade now"
 */
export function extractText(node: ReactNode): string {
  if ([null, undefined, true, false].includes(node as null)) {
    return ""
  }

  const parts: (string | number)[] = []

  React.Children.forEach(node, child => {
    if (typeof child === "string" || typeof child === "number") {
      parts.push(child)
    } else if (React.isValidElement(child)) {
      const text = extractText((child.props as { children?: ReactNode }).children)
      if (text) parts.push(text)
    }
  })

  return parts.join(" ").replace(/\s+/g, " ") // normalize multiple spaces
}
